import Vue from 'vue'

/**
 * Sweetalert wrapper
 */
class Popup {
  constructor (options) {
    //
    this.debug = true
    this.$swal = Vue.prototype.$swal
  }

  error (message, title) {
    return this.$swal({
      title: title || 'Error...',
      text: message || 'Something goes wrong!',
      confirmButtonColor: '#EF5350',
      type: 'error'
    })
  }

  confirm (text, title, type = 'question') {
    return this.$swal({
      title: title || 'Are you sure?',
      text: text || 'Accept action!',
      type: type || 'warning',
      showCancelButton: true,
      confirmButtonColor: type === 'question' ? '#2196f3' : '#FF7043',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    })
  }

  info (text, title) {
    return this.$swal({
      title: title || 'For your information',
      text: text || 'Everything is okay',
      confirmButtonColor: '#2196f3',
      type: 'info'
    })
  }

  success (text) {
    return this.$swal({
      title: 'Success!',
      text: text || 'Everything is okay now',
      confirmButtonColor: '#66BB6A',
      type: 'success'
    })
  }

  warning (text, title) {
    return this.$swal({
      title: title || 'Warning',
      text: text || 'Something goes wrong...',
      type: 'warning',
      confirmButtonColor: '#FF7043'
    })
  }

  inputText (value = '', title = null, placeholder = '', validator = null) {
    if (typeof validator !== 'function') {
      validator = (value) => {
        return true
      }
    }
    return this.$swal({
      title: title || 'Enter value',
      input: 'text',
      inputValue: value || '',
      showCancelButton: true,
      inputPlaceholder: placeholder
    })
  }

  inputEmail (title = null, placeholder = 'Enter email here', validator = null) {
    if (typeof validator !== 'function') {
      validator = (value) => {
        return true
      }
    }
    return this.$swal({
      title: title || 'Enter email',
      input: 'email',
      showCancelButton: true,
      inputPlaceholder: placeholder || ''
    })
  }

  inputUrl (title = null, placeholder = 'Enter URL here', validator = null) {
    if (typeof validator !== 'function') {
      validator = (value) => {
        return true
      }
    }
    return this.$swal({
      title: title || 'Enter URL',
      input: 'url',
      showCancelButton: true,
      inputPlaceholder: placeholder || 'Enter URL here',
      inputValidator: validator
    })
  }

  inputPassword (title = null, placeholder = 'Enter password here', validator = null) {
    if (typeof validator !== 'function') {
      validator = (value) => {
        return true
      }
    }
    return this.$swal({
      title: title || 'Set password',
      input: 'password',
      showCancelButton: true,
      inputPlaceholder: placeholder || 'Enter password here',
      inputAttributes: {
        maxLength: 999,
        autocapitalize: 'off',
        autocorrect: 'off'
      }
    })
  }

  inputSelect (values = {}, title = null, value = '', placeholder = 'Select an option', validator = null) {
    if (typeof validator !== 'function') {
      validator = (value) => {
        return true
      }
    }
    return this.$swal({
      title: title || 'Select value',
      input: 'select',
      inputOptions: values || {},
      inputValue: value || {},
      showCancelButton: true,
      inputPlaceholder: placeholder || 'Enter value'
    })
  }

  inputRadio (values = {}, title = null, value = '', placeholder = 'Select an option', validator = null) {
    if (typeof validator !== 'function') {
      validator = (value) => {
        return true
      }
    }
    return this.$swal({
      title: title || 'Select value',
      input: 'radio',
      inputOptions: values || {},
      inputValue: value || {},
      showCancelButton: true
    })
  }

  inputCheckbox (value = 1, title = null, placeholder = 'I agree', validator = null) {
    if (typeof validator !== 'function') {
      validator = (value) => {
        return true
      }
    }
    return this.$swal({
      title: title || 'Accept',
      input: 'checkbox',
      inputValue: value || 1,
      showCancelButton: true,
      inputPlaceholder: placeholder || 'Accept'
    })
  }

  inputRange (min = 0, max = 100, step = 1, title = null, validator = null) {
    if (typeof validator !== 'function') {
      validator = (value) => {
        return true
      }
    }
    return this.$swal({
      title: title || 'Select number',
      type: 'question',
      input: 'range',
      inputAttributes: {
        min: min || 0,
        max: max || 100,
        step: step || 1
      },
      showCancelButton: true,
      inputValidator: validator
    })
  }
}

const popup = new Popup()
export default popup
